export default [
  { option: [], label: '- Velg byområde -', selected: true, disabled: true },
  { option: ['04', '05', '06', '07', '08'], label: 'Vest' },
  { option: ['01', '02', '03', '09', '10', '11', '12', '13', '14', '15'], label: 'Øst' },
  { option: ['01', '02', '03', '04', '05'], label: 'Indre by' },
  { option: ['01', '02', '03'], label: 'Indre by øst' },
  { option: ['04', '05'], label: 'Indre by vest' },
  { option: ['06', '07', '08', '09', '10', '11', '12', '13', '14', '15'], label: 'Ytre by' },
  { option: ['06', '07', '08'], label: 'Ytre by vest' },
  { option: ['09', '10', '11', '12'], label: 'Ytre by øst' },
  { option: ['13', '14', '15'], label: 'Ytre by sør' },
  {
    option: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15'],
    label: 'Velg alle',
  },
];
